import axios from 'axios';
import {API} from "@/services/url";
import qs from 'qs';

export default {
	getOfficePfConfigList : function (officeId, success, error) {
		axios.get(API.officePfConfig.getOfficePfConfigByOfficeId+officeId)
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},

	saveOfficePfConfig : (officePfConfig, success, error) => {
		axios.post(API.officePfConfig.saveOfficePfConfig,officePfConfig)
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},

}
